<template>
  <div class="multiple-paid">
    <h1 class="normal" id="page-title-for-sr">
      <span class="sr-only">{{ $t('confirmation.pageTitle') }}: </span>
      <span aria-live="assertive" role="status" v-html="$t('confirmation.multiplePaid.header')"></span>
    </h1>
    <p v-html="$t('confirmation.multiplePaid.description')"></p><p v-html="$t('confirmation.multiplePaid.description2')"></p>
  </div>
</template>
<script>
export default {
  name: 'ConfirmationMultiplePaid'
}
</script>
